export default function NormalInputField(props) {
  const required = props.isRequired || props.required;
  return (
    <div>
      <div className="font-semibold uppercase text-[12px] text-gray-600">
        {props.title}{" "}
        <span className="text-red-500">{required ? "*" : null}</span>
      </div>
      <input
        onChange={props.onChange}
        type={props.type}
        disabled={props.disabled}
        placeholder={props.placeholder}
        className="border text-sm focus:border-primary duration-300 font-medium outline-none border-gray-300 p-2 w-full rounded-[4px] disabled:cursor-not-allowed"
        value={props.value}
        autoFocus={props.autoFocus}
        required={required}
        {...props}
      />
    </div>
  );
}


export const NormalTextAreaField = (props) => {
  const required = props.isRequired || props.required;
  const isOptional = props.title.includes("(optional");
  return (
    <div>
      <div className="font-semibold uppercase text-[12px] text-gray-600">
        {isOptional ? (
          <>
            {props.title.split("(optional")[0]}{" "}
            <span className="lowercase text-gray-400 font-normal">
              (Optional)
            </span>{" "}
          </>
        ) : (
          props.title
        )}{" "}
        <span className="text-red-500">{required ? "*" : null}</span>
      </div>
      <textarea
        onChange={props.onChange}
        disabled={props.disabled}
        placeholder={props.placeholder}
        className="border text-sm focus:border-primary duration-300 font-medium outline-none border-gray-300 p-2 w-full rounded-[4px] disabled:cursor-not-allowed"
        value={props.value}
        required={required}
        {...props}
      />
    </div>
  );
};
